/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const InlineRubricViewerEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('INLINE_RUBRIC_VIEWER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class InlineRubricViewerEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return InlineRubricViewerEnabledSettingParser.decode(input).map(res => new InlineRubricViewerEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return InlineRubricViewerEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InlineRubricViewerEnabledSettingParser.encode(data);
    }
    static schema() {
        return InlineRubricViewerEnabledSettingParser.schema();
    }
}
